import React, { useState } from 'react';
import TabsComponent from '../../../../components/Tabs/Tabs';
import Cron from '../../GlobalConfig/CronJobs/Cron';
import CronJobs from '../../GlobalConfig/CronJobs';

const BiddingControl = () => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [cronConfigPage, setCronConfigPage] = useState();

    const tabs = [
        {
            name: 'Crons',
            component: <CronJobs setSelectedIndex={setSelectedIndex} setCronConfigPage={setCronConfigPage} type="bidding" />,
            tabId: 1,
        },

        ...(selectedIndex === 1
            ? [
                  {
                      name: 'Cron config',
                      component: <>{cronConfigPage}</>,
                      tabId: 4,
                  },
              ]
            : []),
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
            />
        </div>
    );
};

export default BiddingControl;
